import { DescribedOption } from '../shared/option-list.component';

export type IncidentGrouping = 'category' | 'severity' | 'status';

export interface IncidentGroupingDefinition extends DescribedOption<IncidentGrouping> {
  /** The Boxwood field `report/count` buckets by */
  field: string;
  /** Translation key for the subtitle, e.g. "By severity · {{count}} open" */
  subtitle: string;
}

export const INCIDENT_GROUPINGS: Record<IncidentGrouping, IncidentGroupingDefinition> = {
  category: {
    value: 'category',
    field: 'incidentType.category.name',
    label: 'Dashboard.IncidentBreakdown.Category',
    description: 'Dashboard.IncidentBreakdown.CategoryDescription',
    subtitle: 'Dashboard.IncidentBreakdown.ByCategory',
    icon: 'category',
  },
  severity: {
    value: 'severity',
    field: 'severityLevel.name',
    label: 'Dashboard.IncidentBreakdown.Severity',
    description: 'Dashboard.IncidentBreakdown.SeverityDescription',
    subtitle: 'Dashboard.IncidentBreakdown.BySeverity',
    icon: 'priority_high',
  },
  status: {
    value: 'status',
    field: 'incidentEventStatus.name',
    label: 'Dashboard.IncidentBreakdown.Status',
    description: 'Dashboard.IncidentBreakdown.StatusDescription',
    subtitle: 'Dashboard.IncidentBreakdown.ByStatus',
    icon: 'pending_actions',
  },
};
